import { render, staticRenderFns } from "./UserManagementPage.vue?vue&type=template&id=83dac4b6"
import script from "./UserManagementPage.vue?vue&type=script&lang=js"
export * from "./UserManagementPage.vue?vue&type=script&lang=js"
import style0 from "./UserManagementPage.vue?vue&type=style&index=0&id=83dac4b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports